import { Link } from "@mui/material";

interface LoginLinkProps {
  text?: string;
  target?: string;
  href?: string;
  onClick?;
}

const SecondaryLink = ({
  text = '',
  target = "self",
  href,
  onClick
}: LoginLinkProps) => {
  return (
    <>
      <Link
        component="a"
        variant="h5"
        target={target}
        href={href}
        onClick={onClick}
        sx={{ textDecoration: 'underline' }}
      >
        {text}
      </Link>
    </>
  );
};

export default SecondaryLink